import { render, staticRenderFns } from "./VoiceDataPatientList.vue?vue&type=template&id=61b01faf&scoped=true"
import script from "./VoiceDataPatientList.vue?vue&type=script&lang=js"
export * from "./VoiceDataPatientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b01faf",
  null
  
)

export default component.exports